<template>
  <div class="dialog-clear-content-wrapper">
    <el-dialog
      class="dialog-clear-content-wrapper-dialog"
      :custom-class="['webapp-center-el-dialog', customClass]"
      :visible.sync="dialogVisible"
      :width="width"
      :show-close="false"
      :before-close="handleClose"
      :append-to-body="appendToBody"
    >
      <slot />
      <div class="footer-white-mask"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogPopup',
  props: {
    show: Boolean,
    customClass: String,
    width: {
      type: String,
      default: '50%',
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    show(nVal) {
      this.init(nVal);
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {
    this.init(this.show);
  },
  methods: {
    init(val) {
      this.dialogVisible = val;
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" >
.dialog-clear-content-wrapper-dialog {
  .el-dialog {
    border-radius: 8px;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 0 24px;
    max-height: 656px;
    min-height: 390px;
    border-radius: 8px;
    background: #f5f5f7;
    overflow: hidden;
  }
  .footer-white-mask {
  }
}
</style>